import GitHubButton from 'react-github-btn';
import Gallery from "../../../../../src/gallery/Gallery.tsx";
import VersionTable from "../../../../../src/components/VersionTable.tsx";
import * as React from 'react';
export default {
  GitHubButton,
  Gallery,
  VersionTable,
  React
};